import {
  Component,
  Input,
  OnInit,
  output,
  input,
  viewChild
} from '@angular/core';

import {
  ChartComponent,
  ApexAxisChartSeries,
  ApexChart,
  ApexXAxis,
  ApexDataLabels,
  ApexTitleSubtitle,
  ApexStroke,
  ApexGrid,
  NgApexchartsModule,
} from 'ng-apexcharts';
import { JkBaseComponent, jkRestReturnClass } from 'jk-service';

// ChartOptions 不要共用,各自定義
type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  dataLabels: ApexDataLabels;
  grid: ApexGrid;
  stroke: ApexStroke;
  title: ApexTitleSubtitle;
};

@Component({
  selector: 'app-line-chart',
  standalone: true,
  imports: [NgApexchartsModule],
  templateUrl: './line-chart.component.html',
  styleUrls: [],
})
export class JkLineChartComponent extends JkBaseComponent implements OnInit {
  readonly chart = viewChild.required<ChartComponent>('chart');
  _stockno: string = '';
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  // TODO: Skipped for migration because:
  //  Accessor inputs cannot be migrated as they are too complex.
  @Input() set stockno(value: string) {
    this._stockno = value;
    if (this._stockno) {
      this.getChartItems(value);
    }
  }
  get stockno(): string {
    return this._stockno;
  }
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input() items: number[] = [];
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input() items_x: string[] = [];
  readonly height = input<number>(180);
  readonly onGetData = output<any>(); //(stockno: string) => void;
  //public chartOptions: Partial<ChartOptions>;
  //chartOpt: ApexChart = this.getApexChart();

  public chartOptions: ChartOptions = {
    series: [
      {
        name: this.label(),
        data: this.items,
      },
    ],
    chart: {
      type: 'line',
      height: this.height(),
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: 'straight',
    },
    title: {
      //text: this.title,
      //align: 'left',
    },
    grid: {
      show: false,
      /*row: {
        colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
        opacity: 0.5,
      },*/
    },
    xaxis: {
      type: 'category', // datetime","numeric"
      categories: this.items_x, // this.items_x,
    },
  };
  constructor() {
    super();
    //this.chartOptions =
  }
  override ngOnInit() {
    super.ngOnInit();
  }
  onChartReady($event: any) {
    /*if (this.onGetData) {
      console.log(this.items_x);
      this.onGetData.emit(this.stockno);
    }*/
  }
  async getChartItems(stockno: string) {
    this.items = [];
    this.items_x = [];
    if (!stockno) return;
    let ret = new jkRestReturnClass();
    await this.orm.doOpenWinAxios(this.login.host,'S','STKLG','S01','','',[stockno],ret);
    if(ret.result){
      let axis = {
        type: 'category', // datetime","numeric"
        categories: [this.items_x], //this.items_x,
      };
      for(let i=ret.obj.length-1; i>=0; i--){
        let item = ret.obj[i];
        this.items.push(item['close']);
        //this.chartOptions.xaxis.categories.push(item['X'] as never);
        this.items_x.push(item['X']);
      }
      this.chartOptions.series = [
        {
          name: this.label(),
          data: this.items,
        },
      ]; // [{ data: this.candleList }]; // this.series2;
      this.chartOptions.xaxis = {
        type: 'category', // datetime","numeric"
        categories: this.items_x, //this.items_x,
      };
    };
    // orm.doOpenWin_get('S', 'STKLG', 'S01', [stockno]).subscribe((data: any) => {
    //   if (data.result) {
    //     //for (let item of data.obj) {
    //     for(let i=data.obj.length-1; i>=0; i--){
    //       let item = data.obj[i];
    //       this.items.push(item['close']);
    //       this.items_x.push(item['FormattedDate']);
    //     }
    //     this.chartOptions.series = [
    //       {
    //         name: this.title,
    //         data: this.items,
    //       },
    //     ]; // [{ data: this.candleList }]; // this.series2;
    //     this.chartOptions.xaxis = {
    //       type: 'category', // datetime","numeric"
    //       categories: [], //this.items_x,
    //     };
    //   };
    // });
  }
}
